'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SellerDetailRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SellerDetailRemote = exports.SellerDetailRemote = {
    fetchSellerDetailsByIds: function fetchSellerDetailsByIds(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment,
            sellerIds = _ref.sellerIds;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>small/seller-detail', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ ids: sellerIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/sellerDetail.js
// module id = FVZ4
// module chunks = 57